import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaPlanoAnualContratacoes: ['exercicio'],
    limpaFiltroConsultaPlanoAnualContratacoes: [],
    receberFiltroConsultaPlanoAnualContratacoes: ['filtroRecebido'],
    setStatusConsultaPlanoAnualContratacoes: ['status'],
})

const INITIAL_STATE = {
    exercicio: '',
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: setExercicio,
    [Types.LIMPA_FILTRO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_PLANO_ANUAL_CONTRATACOES]: setStatus,
})
